import {
  commonMutationTypes,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { MstCustomer } from "../../../../customer/queries/types";

export enum TicketPriorityType {
  CRITICAL = "CRITICAL",
  MAJOR = "MAJOR",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export interface Reasons {
  reason: string;
  priority: TicketPriorityType;
}

export interface AddStockCategoryResultVar {
  token?: string;
  customer_id: number;
  user_details: userDetails;
  input: Reasons;
}

export interface AddStockCategoryResultResult {
  AddTicketReason: boolean;
}

export interface AtsTicketReasons {
  id: number;
  reason: string;
  priority: TicketPriorityType;
  customerID: number;
  customer: MstCustomer;
}

export interface GetTicketReasonsResult {
  GetTicketReasons: AtsTicketReasons[];
}

export interface GetTicketReasonsVar {
  token?: string;
  customer_id: number;
}

export interface UpdateTicketReasonVar {
  token?: string;
  reasons_id: number;
  user_details: userDetails;
  input: Reasons;
}

export interface UpdateTicketReasonResult {
  UpdateTicketReason: boolean;
}

export interface DeleteTicketReasonByIdVars {
  token?: string;
  reasons_id: number;
  user_details: userDetails;
}

export interface DeleteTicketReasonByIdResult {
  DeleteTicketReason: boolean;
}

export interface ReOrderTicketReasonResult {
  ReOrderTicketReason: boolean;
}

export interface ReOrderTicketReasons {
  reasonID: number;
  idx: number;
}

export interface ReOrderTicketReasonVar extends commonMutationTypes {
  customer_id: number;
  input: ReOrderTicketReasons[];
}
